<template>
  <div class="result-game-skip-game t-text">
    <h2>{{ $t('resultView.gameSkipped.headline') }}</h2>
    <i class="icf-alert alert-icon" />
    <div @click="customer" v-html="md($t('resultView.gameSkipped.details'))"></div>
  </div>
</template>

<script setup lang="ts">
import { marked } from 'marked'
const emit = defineEmits(['contact-customer-service'])

function md(text: string): string {
  return marked(text)
}
function customer(e: Event) {
  const event: any = e
  if (event.target && event.target.tagName === 'A' && event.target.href) {
    if (/#customerservice/.test(event.target.href)) {
      emit('contact-customer-service')
    }
  }
  e.preventDefault()
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
.result-game-skip-game {
  margin: 0 auto;
  padding: 2em 3em 0.5em;
  max-width: 34em;
  text-align: center;

  .alert-icon {
    font-size: 3em;
    display: inline-block;
    border-radius: 100%;
    border: 5px solid @c1-g;
    padding: 0;
    width: 5.125rem;
    height: 5.125rem;
    color: @c1-g;
    margin: 0 0.2em;
  }

  .details {
    font-size: 1em;
  }
}
</style>
